<template>
  <van-popup 
    v-model="isVisible"
    :style="{width:'90vw'}"
    class="dialog">
    <div class="dialog-title">
      <div class="dialog-title-txt">{{title}}</div>
      <van-icon class="close-icon" name="cross" size="22" @click="onClose"/>
    </div>
    <div class="dialog-content">
      <template v-if="actionType == 1">
        <van-field type="digit" v-model="form[actionType].joinPeopleNum" label="已参与人数" label-width="16em" placeholder="请输入" />
        <van-field type="digit" v-model="form[actionType].viewPeopleNum" label="已浏览人数" label-width="16em" placeholder="请输入" />
      </template>
      <template v-else-if="actionType == 2">
        <div class="dialog-content-title">经销商角色任务</div>
        <van-field type="digit" v-model="form[actionType].newNumCustomer" label="拉新数" label-width="16em" placeholder="请输入" />
        <van-field type="digit" v-model="form[actionType].registNumCustomer" label="报名数" label-width="16em" placeholder="请输入" />
        <div class="dialog-content-title">店长角色任务</div>
        <van-field type="digit" v-model="form[actionType].newNumStore" label="拉新数" label-width="16em" placeholder="请输入" />
        <van-field type="digit" v-model="form[actionType].registNumStore" label="报名数" label-width="16em" placeholder="请输入" />
        <div class="dialog-content-title">导购角色任务</div>
        <van-field type="digit" v-model="form[actionType].newNumEmployee" label="拉新数" label-width="16em" placeholder="请输入" />
        <van-field type="digit" v-model="form[actionType].registNumEmployee" label="报名数" label-width="16em" placeholder="请输入" />
      </template>
      <div class="field-item" v-else-if="actionType == 3">
        <div class="field-item-title">品牌介绍</div>
        <!-- <van-switch v-model="form[actionType].boolShowIntro" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" /> -->
        <van-radio-group v-model="form[actionType].boolShowIntro" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
      <div class="field-item" v-else-if="actionType == 4">
        <div class="field-item-title">参与成功轮播</div>
        <!-- <van-switch v-model="form[actionType].boolShowNotice" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" /> -->
        <van-radio-group v-model="form[actionType].boolShowNotice" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
      <div class="field-item note" v-else-if="actionType == 5">
        <div class="note-title">
          <div class="field-item-title">报名成功短信设置</div>
          <!-- <van-switch v-model="form[actionType].boolDefinitionSignUpSms" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" /> -->
          <van-radio-group v-model="form[actionType].boolDefinitionSignUpSms" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio :name="false">关闭</van-radio>
            <van-radio :name="true">开启</van-radio>
          </van-radio-group>
        </div>
        <van-field
          class="textarea"
          v-if="form[actionType].boolDefinitionSignUpSms"
          v-model="form[actionType].definitionSignUpSms"
          rows="1"
          type="textarea"
          maxlength="50"
          placeholder="请输入短信内容"
          show-word-limit
        />
      </div>
      <div class="field-item" v-else-if="actionType == 6">
        <div class="field-item-title">地理位置限制</div>
        <!-- <van-switch v-model="form[actionType].boolAreaLimited" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" /> -->
        <van-radio-group v-model="form[actionType].boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="btn-box van-hairline--top">
      <van-button size="large" block @click="onConfirm">确认</van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'TaskConfig',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 1:虚拟数据 2:任务设置 3:品牌介绍 4:参与轮播
    actionType: Number,
    configData: [Object, Array]
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    title() {
      return this.titleMap[this.actionType] || '';
    }
  },
  data() {
    return {
      titleMap: {
        1: '虚拟数据',
        2: '任务设置',
        3: '品牌介绍',
        4: '参与轮播',
        5: '报名成功短信设置',
        6: '秒杀设置'
      },
      form: {
        1: {
          joinPeopleNum: '',
          viewPeopleNum: ''
        },
        2: {
          newNumCustomer: '',
          registNumCustomer: '',
          newNumStore: '',
          registNumStore:'',
          newNumEmployee: '',
          registNumEmployee: '',
        },
        3: {
          boolShowIntro: false
        },
        4: {
          boolShowNotice: false
        },
        5: {
          boolDefinitionSignUpSms: false,
          definitionSignUpSms: ''
        },
        6: {
          boolAreaLimited: ''
        }
      },
      // fieldName对应的id
      fieldIdMaps: {},
      // 组件ID
      moduleId: ''
    }
  },
  methods: {
    initForm() {
      if (!this.configData.moduleItems) {
        return;
      }

      // 品牌介绍
      if (this.actionType === 3) {
        this.initConfData('configCode', 'configValue');
      } else {
        // 报名配置
        this.initConfData('setupColumn', 'setupColumnValue');
      }
    },
    initConfData(keyName, valueName) {
      const fields = Object.keys(this.form[this.actionType]);
      let form = {};
      this.configData.moduleItems.forEach(item => {
        const key = item[keyName];
        const value = item[valueName];
        if (fields.includes(key)) {
          form[key] = key.startsWith('bool') 
            ? value === 'true'
            : value;
        }
      });
      this.form[this.actionType] = form;
    },
    saveSignUpConf() {
      const moduleSetup = [];
      for (const [key, value] of Object.entries(this.form[this.actionType])) {
        moduleSetup.push({
          moduleId: this.configData.moduleId,
          setupColumn: key,
          setupColumnValue: value
        });
      }
      this.$api.activityMgmt.saveSignUpConf({moduleSetup})
        .then(() => {
          this.$toast('保存成功');
          this.onClose();
          this.$emit('refresh')
        });
    },
    saveCommonConf() {
      const params = {
        activityId: this.configData.activityId,
        configCode: 'boolShowIntro',
        configValue: this.form[this.actionType].boolShowIntro
      };
      this.$api.activityMgmt.saveCommonConf(params)
        .then(() => {
          this.$toast('保存成功');
          this.onClose();
          this.$emit('refresh')
        });
    },
    onConfirm() {
      if (this.actionType === 3) {
        this.saveCommonConf();
      } else {
        this.saveSignUpConf();
      }
    },
    onClose() {
      this.isVisible = false;
    }
  },
  created() {
    this.initForm();
  }
}
</script>

<style lang="stylus" scoped>
.dialog
  border-radius: 12px
  .dialog-title
    position relative
    padding 20px 0
    text-align: center
    font-size 16px
    font-weight 500
    &-text
      text-align: center
    .close-icon
      display: inline-block
      position absolute
      right 10px
      top 15px
    
  .dialog-content
    >>> .van-field .van-field__value input
      color #FF6B31
    .dialog-content-title {
      color: #323233;
      margin-left: 15px;
      padding-top: 10px;
      font-weight: bolder;
    }

  .btn-box 
    box-sizing: border-box
    padding 15px 15px 20px
    button
      padding 10px 0
      border-radius 25px
      height: auto
      line-height 1
      color #fff
      background: linear-gradient(#FF8820, #FF6B31)

  .field-item
    // margin 15px 0
    display: flex
    justify-content: space-between
    align-items: center
    padding 10px 16px
    font-size 14px
    background-color: #fff
    border-radius: 8px
    &-title
      color #323233
      // font-weight 600
  .note {
    flex-direction: column;
    .note-title {
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf0;
    }
    .textarea {
      padding-left: 0;
    }
  }
</style>